import { render, staticRenderFns } from "./createUsers.vue?vue&type=template&id=42d5a4c1&"
import script from "./createUsers.vue?vue&type=script&lang=js&"
export * from "./createUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports